import { render, staticRenderFns } from "./ThoraxList.vue?vue&type=template&id=51172330"
import script from "./ThoraxList.vue?vue&type=script&lang=js"
export * from "./ThoraxList.vue?vue&type=script&lang=js"
import style0 from "./ThoraxList.vue?vue&type=style&index=0&id=51172330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports